import axios from 'axios';

const API_URL = `${process.env.APP_URL}`;

const auth = {
  headers: {
    'Access-Control-Allow-Origin': '*',
    'Content-Type': 'application/json',
  },
};

function setCookie(data) {
  const url = `${API_URL}/api/setcookie`;
  return axios.post(url, data, auth).then(response => response.data);
}

function storeSession(data) {
  const url = `${API_URL}/api/storesession`;
  return axios.post(url, data, auth)
  .then(response => response.data)
  .catch(error => {
    console.log(error);
    // window.location.reload();
  });
}

function storeDownload(data) {
  const url = `${API_URL}/api/storedownload`;
  return axios.post(url, data, auth).then(response => response.data);
}

export {
  setCookie,
  storeSession,
  storeDownload,
};



// WEBPACK FOOTER //
// ./src/services/Cookies.js